import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GridReadyEvent } from 'ag-grid-community';
import { useGetRolesQuery } from '../../../services/organizations/organizations.service';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { updateGridModels } from '../../../store/grids';
import { useGetTermSetQuery } from '../../../services/i18n/i18n.service';
import { PLATFORM_DEFS } from '../../../constants/i18n/translations/termSetDefinitions/platform';
import { skipToken } from '@reduxjs/toolkit/query';
import SettingsContext from '../../../contexts/settings.context';

const useRolesGrid = () => {
    const dispatch = useDispatch();
    const { administration } = useSelector((state: RootState) => state.grids);
    const navigate = useNavigate();
    const [gridApi, setGridApi] = useState(null);
    const { data: rowData, isLoading: isLoading } = useGetRolesQuery();
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const { settings } = useContext(SettingsContext);
    const { data: termSet } = useGetTermSetQuery(
        settings?.userSettings
            ? {
                  languageId: settings?.userSettings?.languageId,
                  code: PLATFORM_DEFS.ROLES_GRID,
              }
            : skipToken
    );
    const onGridReady = (params: GridReadyEvent) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const redirectToForm = (row: any) => {
        if (row.id) {
            navigate(`/administration/organizations/roles/${row.id}`);
        } else {
            navigate('/administration/organizations/roles/new');
        }
    };

    const onFirstDataRendered = () => {
        gridColumnApi?.applyColumnState({
            state: administration.rolesList.column,
            applyOrder: true,
        });

        gridApi?.setFilterModel(administration.rolesList.filter);
    };

    const onSortChanged = () => {
        dispatch(
            updateGridModels({
                gridLocation: 'administration',
                gridName: 'rolesList',
                type: 'column',
                model: gridColumnApi.getColumnState(),
            })
        );
    };

    return {
        onGridReady,
        rowData,
        isLoading,
        redirectToForm,
        onSortChanged,
        onFirstDataRendered,
        termSet,
    };
};

export default useRolesGrid;
